import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./login.scss";

const logInfo = {
  email: "Taifurislamashraf.bd@gmail.com",
  password: "Taifur55*#@@",
};

const Login = () => {
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("loginInfo")) {
      navigate("/dashboard", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loginData.email === "" || loginData.password === "") {
      toast.error("Email & password is required", {
        position: "bottom-right",
        autoClose: 4000,
        theme: "dark",
        pauseOnHover: true,
        draggable: true,
        Limit: 1,
      });
    } else if (
      loginData.email === logInfo.email &&
      loginData.password === logInfo.password
    ) {
      localStorage.setItem("loginInfo", loginData);
      navigate("/dashboard", { replace: true });
    } else if (
      loginData.email !== logInfo.email ||
      loginData.password !== logInfo.password
    ) {
      toast.error("Incorect Email or Password", {
        position: "bottom-right",
        autoClose: 4000,
        theme: "dark",
        pauseOnHover: true,
        draggable: true,
        Limit: 1,
      });
    }
  };

  return (
    <div className="login-container">
      <div className="form-containt">
        <h2>Login Dashboard</h2>
        <form onSubmit={handleSubmit}>
          <TextField
            className="login-inp"
            id="outlined-basic 1"
            label="Eamil"
            variant="outlined"
            value={loginData.email}
            type="email"
            name="email"
            fullWidth
            onChange={handleChange}
          />
          <TextField
            className="login-inp"
            id="outlined-basic"
            label="Password"
            variant="outlined"
            fullWidth
            value={loginData.password}
            type="password"
            name="password"
            onChange={handleChange}
          />
          <Button className="login-btn" type="submit">
            Login
          </Button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Login;
